<template>
  <div class="bd">
    <div class="container">
      <div class="title">
        <el-button
          size="medium"
          style="margin-right:7px;position:relative;top:-4px;"
          @click="$router.back()"
        >
          <i class="fa fa-chevron-left fa-fw"></i>
        </el-button>
        {{item.Name}}
      </div>
      <el-timeline>
        <el-timeline-item
          placement="top"
          v-for="version in item.Versions"
          :key="version.ID"
          :timestamp="version.PublishDay.substring(0,10)"
        >
          <el-card>
            <div class="ver">
              {{ version.Version }}
              <el-tag
                v-for="basics in version.Basics"
                :key="basics.ID"
                type="success"
                style="margin-right:7px;font-size:14px;"
              >{{basics.Name}}</el-tag>
            </div>
            <div style="font-size:16px;padding:7px 15px;">
              <div v-html="version.UpdateLog"></div>
            </div>
            <el-row>
              <el-col :span="12">
                <div class="attach">附件:</div>
              </el-col>
              <el-col :span="12">
                <div style="float:right;margin-right:15px;color:#909399;">
                  <span>最低支持:</span>
                  <span class="word">{{ version.MiniNet.Name }}</span>
                  <span class="word">{{ version.MiniSystem.Name }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row style="padding:8px 15px;">
              <el-col v-for="attachment in version.Attachments" :key="attachment.Url" :span="4">
                <a
                  :href="attachment.Url"
                  :download="attachment.Name"
                  style="color:#409eff;"
                >{{ attachment.Name }}</a>
              </el-col>
            </el-row>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      item: {},
    };
  },
  created() {
    this.getItemData();
  },
  methods: {
    getItemData() {
      this.$axios.get(`software/${this.$route.params.ID}/visual`, {
        params: {
          with: ['Versions.Basics', 'Versions.MiniSystem', 'Versions.MiniNet'],
        },
      }).then((response) => {
        this.item = response.data;
        this.item.Versions.reverse();
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.bd {
  min-height: 100vh;
  background-color: #fff;
}
.container {
  width: 1200px;
  margin: 0 auto;
  font-size: 16px;
  color: #303133;
}
.title {
  font-size: 24px;
  font-weight: 600;
  padding: 30px 0px 30px 0px;
}
.detail {
  margin-top: 15px;
  margin-bottom: 40px;
  padding: 15px 30px;
  border: 1px solid #409eff;
}
.info {
  margin-bottom: 10px;
  color: #606266;
}
.sp-line {
  font-size: 20px;
  font-weight: 600;
  padding: 0 20px;
  line-height: 1px;
  border-left: 540px solid #ccc;
  border-right: 540px solid #ccc;
  text-align: center;
}
.word {
  margin-left: 10px;
}
.ver {
  font-size: 18px;
  font-weight: 600;
  padding: 10px;
}
.attach {
  font-size: 14px;
  padding: 10px 0 0 15px;
  color: #909399;
}
</style>
